import BaseEnumType from "../../common/base-enum-type";

const Ruleset = Object.freeze({
    DefaultFootball: new BaseEnumType(
        "DefaultFootballRules",
        "Default Football"
    ),
    DefaultFlagFootball: new BaseEnumType(
        "DefaultFlagFootballRules",
        "Default Flag Football"
    ),
    Cfl: new BaseEnumType("DefaultCflRules", "Canadian Football League"),
    NJCAA2021: new BaseEnumType("NJCAA2021Rules", "NJCAA 2021"),
    IndoorFootball: new BaseEnumType(
        "DefaultIndoorFootballRules",
        "Indoor Football"
    )
});

export default Ruleset;
